import Marquee from "react-fast-marquee";

const items = [
  "Rigueur",
  "Soin du détail",
  "Ponctualité",
  "Finitions soignées",
  "Grand Angoulême",
  "Grand Cognac",
];

const ValuesMarquee = () => (
  <section className="border-y border-ink/10 bg-plaster py-7" data-testid="values-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="mx-8 flex items-center font-serif text-xl italic text-bark md:text-2xl">
          {item}
          <span className="ml-16 text-clay">•</span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default ValuesMarquee;
